module.exports = __webpack_public_path__ + "img/placemark2.0ad018d7.svg";